// chakra imports
import { CircularProgress, Flex, Text } from '@chakra-ui/react';

export function LoadingSpinner({ loading, height, label }) {
	return (
		loading && (
			<Flex
				mb='5'
				alignItems='center'
				justifyContent='center'
				height={height || '50vh'}
				flexDirection='column'
				gap='10px'
			>
				<CircularProgress isIndeterminate color={'brand.500'} />
				<Text>{label || 'Cargando...'}</Text>
			</Flex>
		)
	);
}
